import { gql, type OperationVariables } from '@apollo/client';
import type { IDashboardDTO } from '@sharedInterfaces/IDashboard';
import Dashboard, { dashboardGQL } from '@src/Objects/Dashboard';
import { updateDashboard } from '@store/reducer/dashboardReducer';
import store from '@store/store';

import GraphQL from '../graphQL';

const query = gql`
mutation editDashboard($id: ID!, $obj: EditDashboard!) {
    editDashboard(id: $id, obj: $obj) 
    ${dashboardGQL}
},
`;

/**
 * Updates an existing dashboard.
 *
 * @param {string} id - The ID of the dashboard to update.
 * @param {string} title - The new title of the dashboard.
 * @param {string} description - The new description of the dashboard.
 * @param {string} layout - The new layout configuration of the dashboard.
 * @param {string} widgets - The new widgets configuration of the dashboard.
 * @returns {Promise<Dashboard>} A promise that resolves with the updated dashboard.
 */
export default function editDashboard(
    id: string,
    title: string,
    description: string | null,
    layout: string,
    widgets: string,
) {
    const variables: OperationVariables = {
        id,
        obj: {
            id,
            title,
            description,
            layout,
            widgets,
        },
    };

    return GraphQL.mutate<IDashboardDTO>(query, variables).then((obj) => {
        const updatedDashboard = new Dashboard(obj);
        store.dispatch(updateDashboard(updatedDashboard));
        return updatedDashboard;
    });
}
